import { render, staticRenderFns } from "./MainMenuAdmin.vue?vue&type=template&id=440f09b2"
import script from "./MainMenuAdmin.vue?vue&type=script&lang=js"
export * from "./MainMenuAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports